import React from "react"
import styled from "styled-components"

const Quote = ({ author, quote }) => {
  return (
    <QuoteWrapper>
      <Intro>Once upon a time</Intro>
      <Author>
        {author} <Span>said</Span>
      </Author>
      <Saying>{quote}</Saying>
      <Stick />
    </QuoteWrapper>
  )
}

export default Quote

const marginBottom = (value = "2rem") => `margin-bottom: ${value}rem`

const QuoteWrapper = styled.div`
  padding: 3rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 2rem;

  @media (max-width: 576px) {
    padding: 2rem;
  }
`

const Intro = styled.h3`
  font-weight: 200;
  font-size: 1.6rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  opacity: 0.7;
  ${marginBottom(2.5)};
`

const Author = styled.h2`
  color: var(--mainBlack);
  font-size: 4.5rem;
  font-family: "Merriweather", serif;
  font-weight: 700;
  text-transform: capitalize;
  ${marginBottom(1.75)};
`

const Span = styled.span`
  color: var(--mainGray);
  font-size: 4rem;
  font-style: italic;
  font-weight: 200;
  text-transform: lowercase;
`

const Saying = styled.blockquote`
  line-height: 1.5;
  letter-spacing: 1px;
  ${marginBottom(5)};
`

const Stick = styled.div`
  height: 1px;
  width: 5rem;
  background: var(--mainPink);
`
